// Structural type so both `ILegacyCartEntry` and `IBackendCartEntries` (which lacks `_id`) can
// be passed without a cast — only the fields actually read here are required.
interface ICartEntryRefInput {
  sanityId?: string;
  _id?: string;
  quantity: number;
  children?: ICartEntryRefInput[];
}

export const getCartEntryRef = (entry: ICartEntryRefInput): string => {
  const sanityId = entry?.sanityId || entry?._id;
  const childrenRefs = entry?.children
    ?.map(child => getCartEntryRef(child))
    .sort()
    .join(',');
  return `${sanityId}(${entry.quantity})[${childrenRefs}]`;
};

// Ref format used by the minimal-cart quick-favorite flows (`cart-entry-fab-button.tsx`,
// `minimal-recent-entry-favorite-button.tsx`) — distinct from `getCartEntryRef` above, which is
// the legacy-cart format. Multi-item minimal favorites (saved with a custom title) store
// `rbiOrderId` as their ref instead, so matching this format reliably identifies a single-item
// quick-favorite on the minimal-cart side too.
export const getMinimalCartEntryRef = (entry: { id: string; quantity: number }): string =>
  `${entry.id}(${entry.quantity})`;
